import React, { FC, useMemo } from 'react';

import { FormInput } from 'Shared/components';

import { AgentPaymentPreferenceFrequencySelectorProps } from './types';
import styles from './styles.module.css';

export const AgentPaymentPreferenceFrequencySelector: FC<AgentPaymentPreferenceFrequencySelectorProps> = ({
  value,
  options,
  disabled,
  onChange,
}) => {
  const selectOptions = useMemo(() => {
    return options.reduce<Record<string, string>>((acc, option) => {
      acc[option.value] = option.label;
      return acc;
    }, {});
  }, [options]);

  return (
    <FormInput
      data-testid="agent-payment-preference-frequency"
      variant="selectAutocomplete"
      name="agentPaymentPreferenceFrequency"
      label="Frequency"
      value={value ?? ''}
      disabled={disabled}
      className={styles.frequencySelector}
      options={selectOptions}
      onChange={(selectedValue: string) => {
        onChange(
          selectedValue as NonNullable<
            AgentPaymentPreferenceFrequencySelectorProps['value']
          >
        );
      }}
    />
  );
};
